import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '@/pages/service/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.authService.token;

        const cloned = token ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) }) : req;

        return next.handle(cloned).pipe(
            catchError((error: HttpErrorResponse) => {
                // Sesión expirada / token inválido en una petición autenticada: sacamos al usuario al login.
                if (error.status === 401 && token) {
                    this.authService.clearSession();
                    this.router.navigate(['/auth/login'], { queryParams: { motivo: 'inactividad' } });
                }
                return throwError(() => error);
            })
        );
    }
}
